import { withTranslation } from "react-i18next";

import RedeemtionDetail from './RedeemtionDetail';

export default withTranslation()(RedeemtionDetail);